<template>
  <section>
    <template v-if="parsedConfig.title">
      <div class="row">
        <div class="col-xs-8">
          <h3>
            {{parsedConfig.title}}
          </h3>
        </div>
        <div class="col-xs-4">
          <a :id="`download-${moduleIndex}`"
             :download="`${pageInfo.name.toLowerCase().split(' ').join('_')}_${parsedConfig.title.toLowerCase().split(' ').join('_')}.jpeg`"
             href=""
             @click="downloadChart"
             class="btn btn-success bg-flat-color-1 pull-right"
             title="Export">

            <!-- Download Icon -->
            <i class="fa fa-cloud-download mr-5"></i>Export
          </a>
        </div>
      </div>
    </template>
    <pie-chart
        :endpoint="endpoint"
        :config="parsedConfig"
        v-show="!loading && !empty"
        @loading="loading = true"
        @finished="loading = false"
        @noData="empty = true"
        @yesData="empty = false"
        :border="'#1ACA1A'"
        :chart-id="chartId"
        :rgbStyle="'0, 255, 0'"
        :title="'ecommerce'"
        :filters="filters"
        :orderDirection="sort">
    </pie-chart>
    <div class="row" v-show="loading">
      <div class="col-xs-12">
        <i class="fa fa-spinner fa-spin fa-2x loading"></i>
      </div>
    </div>
    <div class="callout callout-info" v-show="!loading && empty">
      <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
      <p>Es sind keine data vorhanden</p>
    </div>
  </section>
</template>

<script>
  import { bus } from "../main";
  import PieChart from "./Charts/PieChart";
  import moment from "moment";
  export default {
    props: ['endpoint', 'pageInfo', 'moduleIndex', 'config'],
    name: "ChartPie",
    components: {PieChart},
    data () {
      return {
        loading: true,
        empty: true,
        companies: [],
        date: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment(new Date(2017, 0, 1)).format('YYYY-MM-DD')
        },
        salesChannels: [],
        sort: 'desc',
        brands: [],
        products: [],
        category: '',
        subCats: ''
      }
    },
    computed: {
      chartId () {
        return `${this.pageInfo.name.toLowerCase().split(' ').join('_')}_${this.parsedConfig.title.toLowerCase().split(' ').join('_')}_${this.moduleIndex}`
      },
      parsedConfig () {
        return JSON.parse(this.config)
      },
      filters () {
        return {
          companies: this.companies,
          salesChannels: this.salesChannels,
          date: this.date,
          category: this.category,
          subcategories: this.subCats,
          sort: this.sort,
          orderField: this.orderField,
          brands: this.brands,
          products: this.products
        }
      }
    },
    created() {
      bus.$on('updatedFilters', (data) => {
        this.companies = data.companies
        this.date = data.date
        this.salesChannels = data.salesChannels
        this.category = data.category
        this.subCats = data.subcategories
        this.sort = data.sort
        this.brands = data.brands
        this.products = data.products
      })
    },
    beforeDestroy () {
      bus.$off('updatedFilters')
    },
    methods: {
      downloadChart () {
        let canvas = document.getElementById(this.chartId)
        let destinationCanvas = document.createElement('canvas')
        destinationCanvas.width = canvas.width
        destinationCanvas.height = canvas.height
        let destCtx = destinationCanvas.getContext('2d')
        destCtx.fillStyle = '#FFFFFF'
        destCtx.fillRect(0,0, canvas.width, canvas.height)
        destCtx.drawImage(canvas, 0, 0)
        let url_base64jp = destinationCanvas.toDataURL("image/jpeg");
        /*get download button (tag: <a></a>) */
        let a =  document.getElementById(`download-${this.moduleIndex}`);
        /*insert chart image url to download button (tag: <a></a>) */
        a.href = url_base64jp;
        destCtx.clearRect(0,0, canvas.width, canvas.height)
      }
    },
    mounted () {
    },
    watch: {
    }
  }
</script>

<style scoped>

</style>
